import React, { Component } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { IntlProvider, addLocaleData } from 'react-intl'

import esLocaleData from 'react-intl/locale-data/es'
import euLocaleData from 'react-intl/locale-data/eu'
import enLocaleData from 'react-intl/locale-data/en'
import translations from 'i18n/locales'

import App from './App'
import AppTools from 'utils/app/appTools'
import Config from 'utils/config'

import ReactHighcharts from 'react-highcharts'
import ReactHighmaps from 'react-highcharts/ReactHighmaps.src'

import HighchartsMore from 'highcharts-more'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'
import HighchartsData from 'highcharts/modules/data'
import HighchartsExportCSV from 'highcharts-export-csv/export-csv'

ReactHighcharts.Highcharts.setOptions({
  lang: {
    numericSymbols: null
  },
  exporting: {
    // url: "http://localhost:7801"
  }
})

HighchartsMore(ReactHighcharts.Highcharts)
HighchartsExporting(ReactHighcharts.Highcharts)
HighchartsExporting(ReactHighmaps.Highcharts)
HighchartsOfflineExporting(ReactHighcharts.Highcharts)
HighchartsOfflineExporting(ReactHighmaps.Highcharts)
HighchartsExportData(ReactHighcharts.Highcharts)
HighchartsExportData(ReactHighmaps.Highcharts)
HighchartsData(ReactHighcharts.Highcharts)
HighchartsData(ReactHighmaps.Highcharts)
HighchartsExportCSV(ReactHighcharts.Highcharts)
HighchartsExportCSV(ReactHighmaps.Highcharts)


addLocaleData(esLocaleData)
addLocaleData(euLocaleData)
addLocaleData(enLocaleData)

class SetUp extends Component {
  constructor() {
    super();
    // const config = window._config;
    // console.log(config);
    Config.fromObject( window._config );
  }

  render() {
    const selectedLanguage = AppTools.getDefaultLanguage()
    return (
      <IntlProvider locale={selectedLanguage} key={selectedLanguage} messages={translations[selectedLanguage]}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </IntlProvider>
    )
  }
}

export default SetUp



// WEBPACK FOOTER //
// ./src/setup/SetUp.jsx